import * as R from 'remeda';
import { ActionType } from 'typesafe-actions';

import * as improvementsActions from './actions';
import * as improvementsConstants from './constants';
import improvementsReducer from './reducer';
import * as improvementsSagas from './sagas';
import * as improvementsSelectors from './selectors';

export type ImprovementsState = {
  activeTabId: 'suggestions' | 'actions' | 'simulate';
  selectedSuggestionId: null | string;
  selectedActionId: null | string;
  // Shared improvement-area chip filter. Empty array = show all rows; the
  // sentinel `UNASSIGNED_AREA_ID` represents rows with null improvementAreaId.
  // Persists across the Suggestions/Actions tab switch.
  selectedAreaIds: string[];
  // Actionboard sub-view state — drives the (currently commented-out) simulate
  // tab's week stepper + zone/activity resolution toggle.
  actionboard: {
    selectedWeek: Time.Week;
    selectedEntityId: null | string;
  };
};

export type ImprovementsAction = ActionType<typeof improvementsActions>;

const _improvementsSagaActions = R.pick(improvementsActions, [
  'startCreateActionFromSuggestion',
  'startSaveSuggestion',
  'startCreateMockSuggestion',
  'startRejectSuggestion',
  'startDeleteSuggestion',
  'startUpdateAction',
  'startDeleteAction',
  'startCreateMockAction',
  'startAddAction',
]);

export type ImprovementsSagaAction = ActionType<
  typeof _improvementsSagaActions
>;

export {
  improvementsActions,
  improvementsConstants,
  improvementsReducer,
  improvementsSagas,
  improvementsSelectors,
};
